import React from "react";
import { Tooltip, TooltipProps, useTheme, alpha } from "@mui/material";

interface CustomTooltipProps extends TooltipProps {
    noPadding?: boolean; // nouveau prop pour contrôler le padding
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ noPadding, ...props }) => {
    const theme = useTheme();

    return (
        <Tooltip
            {...props}
            PopperProps={{
                style: {
                    zIndex: 1200, // < dialog (1300)
                },
                container: document.body,
            }}
            componentsProps={{
                tooltip: {
                    sx: {
                        ...(noPadding ? { padding: 0 } : {}), // conditionnel
                        backgroundColor: theme.palette.mode === 'dark'
                            ? alpha(theme.palette.grey[800], 0.95)
                            : alpha(theme.palette.background.paper, 0.95),
                        color: theme.palette.text.primary,
                        fontSize: theme.typography.pxToRem(13),
                        lineHeight: 1.5,
                        '& .MuiTypography-root': {
                            fontSize: theme.typography.pxToRem(13),
                            lineHeight: 1.5,
                        },
                        border: '1px solid rgba(145, 158, 171, 0.1)',
                        borderBottom: '1px solid rgba(145, 158, 171, 0.4)',
                        borderColor: theme.palette.divider,
                        boxShadow: theme.palette.mode === 'dark'
                            ? '0 4px 12px rgba(0, 0, 0, 0.3)'
                            : '0 4px 12px rgba(0, 0, 0, 0.1)',
                    },
                },
                arrow: {
                    sx: {
                        color: theme.palette.mode === 'dark'
                            ? alpha(theme.palette.grey[800], 0.95)
                            : alpha(theme.palette.background.paper, 0.95),
                    },
                },
            }}
        />
    );
};

export default CustomTooltip;
